export const buildTemporaryCastellerInfo = (newPersonId, displayName) => ({
    'id': newPersonId,
    'is_temporary': 1,
    'mote': displayName,
    'nom': displayName,
    'cognom': '',
    'altura': null,
    'canalla': '0',
    'music': '0',
    'lesionat': '0',
    'casteller': '1',
    'assistència': 1,
    'assistencia': 'Vinc'
});

export const requestNewPerson = ({
    socket,
    mote,
    provaId,
    eventId,
    requestId = createTemporaryRequestId(),
    onSuccess = () => {},
    onError = () => {},
}) => {
    let completed = false;
    const complete = response => {
        if (completed) return;
        completed = true;
        const newPersonId = response?.newPersonId;
        if (!response?.success || !newPersonId) {
            onError(response?.error || 'No s’ha pogut crear el temporal.');
            return;
        }
        onSuccess({ ...response, newPersonId, requestId });
    };
    // Preserve the positional socket contract; temporary identities use only the nickname.
    const args = ['.new_person', '-', '-', mote, null, provaId, eventId, { requestId }];
    if (socket.connected === false) {
        complete({ success: false, error: 'No hi ha connexió. Torna-ho a provar quan es recuperi.' });
        return;
    }
    if (typeof socket.timeout === 'function') {
        socket.timeout(15000).emit(...args, (error, response) => {
            if (error) complete({ success: false, error: 'No s’ha rebut resposta. Torna-ho a provar amb el mateix nom i caixa.' });
            else complete(response);
        });
    } else socket.emit(...args, complete);
};

export const createTemporaryRequestId = () => {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
};
